// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/img/forester-film-edits-9.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k5ppDul8KDJObz5jno_w {
  position: relative;
  width: 100%;
  height: 40rem;
  margin: auto;
  overflow: hidden;
  margin-bottom: 1.5rem;
  padding-top: 1rem;
  clip-path: polygon(75% 5%, 100% 0, 100% 100%, 49% 96%, 25% 100%, 0 93%, 0 0);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-attachment: scroll;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.lLj8b8N8hv0CUYek4MAw {
  max-width: 1560px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  position: relative;
}

.Haa1XkWbPWq3uO05xDAb {
  display: flex;
  transition: transform 0.5s ease-in-out;
}

.rH3TneSeMPN9Ym3micOW {
  flex: 0 0 25%;
  box-sizing: border-box;
  padding: 0 20px;
}

.rH3TneSeMPN9Ym3micOW img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  transition: transform 0.3s ease;
}
.rH3TneSeMPN9Ym3micOW img:hover {
  transform: scale(1.05);
}

.kymANabxy3OqEioxo3Da,
.MNM4ksbepXpREG24X5Lg {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  font-size: 2rem;
  cursor: pointer;
  padding: 1rem;
  z-index: 10;
  background-color: transparent;
  color: white;
}

.kymANabxy3OqEioxo3Da {
  left: -50px;
}

.MNM4ksbepXpREG24X5Lg {
  right: -50px;
}

@media screen and (max-width: 768px) {
  .k5ppDul8KDJObz5jno_w {
    width: 100vw;
    height: 20rem;
    margin: 0;
    margin-bottom: -2rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    margin-top: -6rem;
  }
  .Haa1XkWbPWq3uO05xDAb {
    width: 100%;
  }
  .rH3TneSeMPN9Ym3micOW {
    flex: 0 0 100%;
    padding: 0 10px;
  }
  .kymANabxy3OqEioxo3Da,
  .MNM4ksbepXpREG24X5Lg {
    font-size: 1.5rem;
    padding: 0.5rem;
    left: -25px;
    right: -25px;
  }
}
@media screen and (max-width: 500px) {
  .k5ppDul8KDJObz5jno_w {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AlbumCarousel/AlbumCarousel.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,4EAAA;EACA,yDAAA;EACA,6BAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,sCAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;AACF;AACE;EACE,sBAAA;AACJ;;AAGA;;EAEE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,6BAAA;EACA,YAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE;IACE,YAAA;IACA,aAAA;IACA,SAAA;IACA,oBAAA;IACA,yDAAA;IACA,iBAAA;EAAF;EAGA;IACE,WAAA;EADF;EAIA;IACE,cAAA;IACA,eAAA;EAFF;EAKA;;IAEE,iBAAA;IACA,eAAA;IACA,WAAA;IACA,YAAA;EAHF;AACF;AAMA;EACE;IACE,yDAAA;IACA,sBAAA;EAJF;AACF","sourcesContent":[".carouselContainer {\n  position: relative;\n  width: 100%;\n  height: 40rem;\n  margin: auto;\n  overflow: hidden;\n  margin-bottom: 1.5rem;\n  padding-top: 1rem;\n  clip-path: polygon(75% 5%, 100% 0, 100% 100%, 49% 96%, 25% 100%, 0 93%, 0 0);\n  background-image: url('/public/img/forester-film-edits-9.jpg');\n  background-attachment: scroll;\n  background-size: cover;\n  background-position: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.carousel {\n  max-width: 1560px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: auto;\n  position: relative;\n}\n\n.carouselInner {\n  display: flex;\n  transition: transform 0.5s ease-in-out;\n}\n\n.carouselItem {\n  flex: 0 0 25%;\n  box-sizing: border-box;\n  padding: 0 20px;\n}\n\n.carouselItem img {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n  transition: transform 0.3s ease;\n\n  &:hover {\n    transform: scale(1.05);\n  }\n}\n\n.prevButton,\n.nextButton {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  border: none;\n  font-size: 2rem;\n  cursor: pointer;\n  padding: 1rem;\n  z-index: 10;\n  background-color: transparent;\n  color: white;\n}\n\n.prevButton {\n  left: -50px;\n}\n\n.nextButton {\n  right: -50px;\n}\n\n@media screen and (max-width: 768px) {\n  .carouselContainer {\n    width: 100vw;\n    height: 20rem;\n    margin: 0;\n    margin-bottom: -2rem;\n    background-image: url('/public/img/forester-film-edits-9.jpg');\n    margin-top: -6rem;\n  }\n\n  .carouselInner {\n    width: 100%;\n  }\n\n  .carouselItem {\n    flex: 0 0 100%;\n    padding: 0 10px;\n  }\n\n  .prevButton,\n  .nextButton {\n    font-size: 1.5rem;\n    padding: 0.5rem;\n    left: -25px;\n    right: -25px;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .carouselContainer {\n    background-image: url('/public/img/forester-film-edits-9.jpg');\n    background-size: cover;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carouselContainer": `k5ppDul8KDJObz5jno_w`,
	"carousel": `lLj8b8N8hv0CUYek4MAw`,
	"carouselInner": `Haa1XkWbPWq3uO05xDAb`,
	"carouselItem": `rH3TneSeMPN9Ym3micOW`,
	"prevButton": `kymANabxy3OqEioxo3Da`,
	"nextButton": `MNM4ksbepXpREG24X5Lg`
};
export default ___CSS_LOADER_EXPORT___;
